import React from "react";
import { Form, Input, Radio, Select, DatePicker } from "antd";
import moment from "moment";
const { Option } = Select;
const { TextArea } = Input;
export function FormComponent({
  formItemLayout,
  getFieldDecorator,
  input,
  option,
  showOther,
  onChange,
  onSearch,
  technicalSkills,
  itemData
}) {
  const isEdit = itemData !== null;
  return (
    <Form {...formItemLayout}>
      <Form.Item label="Hackathon Title" className="formsteponeinout">
        {getFieldDecorator("hackathonName", {
          initialValue: itemData ? itemData.hackathonName : undefined,
          rules: [
            {
              required: true,
              message: "Hackathon Title"
            }
          ]
        })(<Input placeholder="Enter Hackathon Title" disabled={isEdit} />)}
      </Form.Item>
      <Form.Item
        label="Authority or Company conducted this Hackathon"
        className="formsteponeinout"
      >
        {getFieldDecorator("hackathonAuthority", {
          initialValue: itemData ? itemData.hackathonAuthority : undefined,
          rules: [
            {
              required: true,
              message: "Please enter name of Company/Authority"
            }
          ]
        })(<Input placeholder="Enter name of Company/Authority" />)}
      </Form.Item>

      <Form.Item label="Description" className="formsteponeinout">
        {getFieldDecorator("hackathonDescription", {
          initialValue: itemData ? itemData.hackathonDescription : undefined,
          rules: [
            {
              required: true,
              message: "Please enter your hackathon description"
            }
          ]
        })(
          <TextArea
            placeholder="Please enter more details about hackathon"
            autosize
          />
        )}
      </Form.Item>

      <Form.Item
        label="Have you attended this hackathon at an offline event or online website?"
        className="formsteponeinout"
      >
        {getFieldDecorator("hackathonType", {
          initialValue: itemData ? itemData.hackathonType : undefined,
          rules: [
            {
              required: true,
              message: "Please select the answer"
            }
          ]
        })(
          <Radio.Group>
            <Radio value="offline">Offline</Radio>
            <Radio value="online">Online</Radio>
            <Radio value="Other">Other</Radio>
          </Radio.Group>
        )}
      </Form.Item>

      <Form.Item
        label="Result"
        className="formsteponeinout"
      >
        {getFieldDecorator("hackathonResult", {
          initialValue: itemData ? itemData.hackathonResult : undefined,
          rules: [
            {
              required: true,
              message: "Please select the answer"
            }
          ]
        })(
          <Radio.Group>
            <Radio value="Participated">Participated</Radio>
            <Radio value="Winner">Winner</Radio>
            <Radio value="Runner-up">Runner-up</Radio>
            <Radio value="Finalist">Finalist</Radio>
            <Radio value="Other">Other</Radio>
          </Radio.Group>
        )}
      </Form.Item>

      <Form.Item
        label="Hackathon Date ?(Approx)"
        className="formsteponeinout"
      >
        {getFieldDecorator("hackathonDate", {
          initialValue: itemData
            ? moment(itemData.hackathonDate, "MMMM Do YYYY")
            : undefined,
          rules: [
            {
              required: true,
              message: "Tell us the approx Hackathon Date"
            }
          ]
        })(<DatePicker />)}
      </Form.Item>
    </Form>
  );
}

